<template>
  <div id="app">
    <head-Back title="智能计算器"></head-Back>
    <div class="page">
      <p>{{welcome}}</p>
      <p>快去下载app使用吧</p>
      <button @click="downapp()">立即下载使用</button>
    </div>

    <div class="tan" :class="{tanhide:codeshow}">
      <div class="tan-page">
        <p>安卓端可以正常下载使用</p>
        <p>ios端即将上线</p>
      </div>
      <div class="tan-foot" @click="closeTan">
        <span>我知道了</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:codeshow}"></div>

    <div class="tan" :class="{tanhide:copyshow}">
      <div class="tan-head">
        <img :src="closeSrc" @click="closeCopyshow" />
      </div>
      <div class="tan-page">
        <p>
          请点击下方按钮,
          <br />复制到浏览器打开下载
        </p>
      </div>
      <div class="tan-foot" v-clipboard:copy="invitationCode" v-clipboard:success="copy">
        <span>复制浏览器打开</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:copyshow}"></div>

    <div class="test" v-show="showFlag">下载中</div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
import axios from "@/utils/axiosExport";

//toast组件
import tips from "@/estoast";

export default {
  name: "app",
  metaInfo: {
    title: "好运吧"
  },
  data() {
    return {
      msg: "注册协议",
      welcome: "恭喜你！登录成功",
      codeshow: true,
      closeSrc: require("../../assets/img/close@2x.png"),
      copyshow: true,
      channel: "clac_android_V1.0.0_g_sign.apk",
      userid: null,
      showFlag: false,
      invitationCode: "",
      registerFlag: 2,
      cid:'',
    };
  },
  mounted() {
    this.$point.init(new Date());
    this.invitationCode = window.location.href;

    var channelId = this.$route.params.channelId;
    console.log("sharchannelIdeid:" + channelId);
    // this.type =type;
    // this.shareid =shareid;
    // if(!util.isNum(this.channelId)){
    //     tips.toast("地址不合法")
    //     this.$router.push("/index");
    // }
    var cid = this.$route.params.cid;
    this.cid = cid;
    if (
      "C001001" == cid ||
      "C001002" == cid ||
      "C001002" == cid ||
      "C001003" == cid ||
      "C001004" == cid ||
      "C001005" == cid ||
      "C001006" == cid ||
      "C001007" == cid ||
      "C001008" == cid ||
      "C001009" == cid ||
      "C001011" == cid ||
      "C001014" == cid ||
      "C001013" == cid ||
      "C001012" == cid
    ) {
      this.channel = "clac_android_V1.0.0_100_" + cid + "_sign.apk";
    }
    console.log("cid：" + cid);
    var userid = this.$route.params.userid;
    if (userid) {
      this.userid = userid;
    }
    console.log("userid" + userid);
    var registerFlag = this.$route.params.registerFlag;
    if (registerFlag == 1) {
      this.welcome = "恭喜你！注册成功";
      this.registerFlag = 1;
    }
    if (/(Android)/i.test(navigator.userAgent)) {
      //下载
      this.invitationCode = "http://calc.haoyunba.com/apk/" + this.channel;
    }
  },
  methods: {
    copy(e) {
      console.log(e);
      tips.toast("复制成功");
      this.codeshow = true;
      this.copyshow = true;
    },

    // 导出 或 下载
    exportDoc(url) {
      let URL = url;
      let me = this;


      me.showFlag = true;
      axios
        .get(URL)
        .then(function(response) {

          me.showFlag = false;

          if (response == "200") {
            tips.toast("下载成功！");

            if(me.cid.indexOf('gdt') > 0){
                gdt('track', 'DOWN_APP', {'eid': 'btn_100008','cid':me.cid});
            }

          } else {
            tips.toast("下载失败！");
          }
        })
        .catch(function(response) {
          console.log(response);
        });
    },

    closeTan: function() {
      this.codeshow = true;
    },
    closeCopyshow: function() {
      this.copyshow = true;
    },
    downapp() {
      this.$point.eventtag(this.userid, "btn_100008");
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (/(Android)/i.test(navigator.userAgent)) {
          //下载
          this.invitationCode = "http://calc.haoyunba.com/apk/jsq_android_V1.0.0_gw_sign.apk" ;
        }
        // 是微信端
        this.copyshow = false;
        return;
      } else {
        if (/(Android)/i.test(navigator.userAgent)) {
          //下载
          window.location.href = "http://calc.haoyunba.com/apk/jsq_android_V1.0.0_gw_sign.apk";

          // this.exportDoc(
          //   window.location.protocol +
          //     "//" +
          //     window.location.host +
          //     "/apk/clac/" +
          //     this.channel
          // );

          this.$point.eventuid(
            "down_app_" + this.channel,
            this.userid,
            "down_app"
          );
        } else {
          //window.location = "https://apps.apple.com/cn/app/id1502944777";
          //  this.codeshow = false;
        
        //使用企业签签名作为下载的标识
            setTimeout(() => {
              this.$router.push("/iosSetting");
            }, 2000);

            window.location.href =
              "itms-services://?action=download-manifest&url=https://www.haoyunba.com/h5/ios/clac/manifest.plist";

        }
      }
      if (this.registerFlag == 1) {
        _ks_trace.push({
          event: "form",
          convertId: 38921,
          cb: function() {
            console.log("点击下载");
          }
        });
      }
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1334px;
  background: rgba(255, 255, 255, 1);
}
.page {
  margin-top: 40%;
}
button {
  width: 632px;
  height: 92px;
  background: linear-gradient(
    180deg,
    rgba(45, 80, 237, 1) 0%,
    rgba(78, 160, 254, 1) 100%
  );
  box-shadow: 0px 4px 12px 4px rgba(202, 222, 255, 1);
  border-radius: 50px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 92px;
  border: none;
}
p {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
}

.tan {
  position: fixed;
  z-index: 9999;
  top: 428px;
  margin: 0 auto;
  position: fixed;
  width: 540px;
  height: 300px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  margin: 0px 104px 0px 106px;
  z-index: 99999;
}

.tan-back {
  position: fixed;
  z-index: 99998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
}

.tan-head {
  width: 100%;
  height: 50px;
}
.tan-head img {
  position: relative;
  width: 32px;
  height: 32px;
  float: right;
  margin: 16px 20px 0 0;
}
.tan-page {
  width: 100%;
  height: 200px;
}
.tan-foot {
  width: 540px;
  height: 102px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(56, 48, 234, 1) 100%
  );
  border-radius: 0px 0px 16px 16px;
}

.tan-foot span {
  width: 240px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 100px;
}

.tan-page-text {
  width: 100%;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 38px;
  padding: 20px 0 0 0;
}
.tan-page-code {
  width: 476px;
  height: 100px;
  padding: 30px 0 0 32px;
}
.tan-page-code div {
  float: left;
}

.tan-page-code-img {
  width: 190px;
  height: 92px;
  border-radius: 61px;
}

.tan-page-code-img img {
  width: 190px;
  height: 92px;
}

.tan-page-code-input {
  width: 272px;
  height: 92px;
  margin: 0 0 0 14px;
}
.tan-page-code-input input {
  width: 202px;
  height: 61px;
  background: rgba(247, 247, 247, 1);
  border-radius: 61px;
  border: none;
  padding: 15px 35px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  text-align: center;
}

.tan-page-code-input input::-webkit-input-placeholder {
  position: relative;
  left: 20px;
  width: 172px;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  margin-left: -10px;
}
.tanhide {
  display: none;
}
.test {
  position: fixed;
  top: 50%;
  left: 36%;
  bottom: 0;
  right: 0;
  width: 200px;
  height: 80px;
  background: rgba(0, 0, 0, 0.4);
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: white;
  line-height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/channel/chanelResult.vue